'use strict';

module.exports = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
        /**
         * Need $anchorScroll, $timeout
         * @param {type} id
         * @param {type} effect
         * @param {type} scrollTo boolen
         * @return {undefined}
         */
        return function (id, effect, scrollTo) {
            id = id.replace('#', '');
            if (scrollTo) {
                $anchorScroll(id);
            }
            if (effect) {
                $timeout(function () {
                    angular.element('#' + id).removeClass("animated");
                    angular.element('#' + id).removeClass(effect);
                }, 1000);
                angular.element('#' + id).addClass("animated " + effect);
            }
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/animate/AnimateIt.js
// module id = 388
// module chunks = 0